var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Media / Icons / General / Lock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6666 5.83341H11.3333C11.8637 5.83341 12.3724 6.04412 12.7475 6.41919C13.1226 6.79426 13.3333 7.30297 13.3333 7.83341V13.1667C13.3333 13.6972 13.1226 14.2059 12.7475 14.581C12.3724 14.956 11.8637 15.1667 11.3333 15.1667H4.66663C4.13619 15.1667 3.62749 14.956 3.25241 14.581C2.87734 14.2059 2.66663 13.6972 2.66663 13.1667V7.83341C2.66663 7.30297 2.87734 6.79426 3.25241 6.41919C3.62749 6.04412 4.13619 5.83341 4.66663 5.83341H5.33329V4.5734C5.33329 3.86616 5.61424 3.18788 6.11434 2.68779C6.61444 2.18769 7.29272 1.90674 7.99996 1.90674C8.7072 1.90674 9.38548 2.18769 9.88558 2.68779C10.3857 3.18788 10.6666 3.86616 10.6666 4.5734V5.83341ZM7.04281 3.59474C6.79292 3.85837 6.65766 4.21027 6.66663 4.5734V5.83341H9.33329V4.5734C9.34226 4.21027 9.20699 3.85837 8.9571 3.59474C8.70721 3.3311 8.36305 3.17721 7.99996 3.16674C7.63686 3.17721 7.2927 3.3311 7.04281 3.59474ZM7.07401 9.11438C7.34809 8.93124 7.67032 8.8335 7.99996 8.8335C8.44199 8.8335 8.86591 9.00909 9.17847 9.32165C9.49103 9.63421 9.66663 10.0581 9.66663 10.5002C9.66663 10.8298 9.56888 11.152 9.38574 11.4261C9.20261 11.7002 8.94231 11.9138 8.63776 12.04C8.33322 12.1661 7.99811 12.1991 7.67481 12.1348C7.35151 12.0705 7.05454 11.9118 6.82145 11.6787C6.58836 11.4456 6.42963 11.1486 6.36532 10.8253C6.30101 10.502 6.33401 10.1669 6.46016 9.86236C6.58631 9.55781 6.79993 9.29752 7.07401 9.11438Z",
    fill: "#1271A6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.f281c25e19cd9a3b8c370977dff02e39.svg";
export { ForwardRef as ReactComponent };